// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.h1__uq7wp {
}
.h2__UkTyQ {
}
.h3__gNEMf {
}
.h4__qLv9n {
}
.h5___29pp {
}
.h6__ft0kw {
}
`, "",{"version":3,"sources":["webpack://./src/sharetribe/components/Heading/Heading.module.css"],"names":[],"mappings":"AAEA;AAEA;AAEA;AAEA;AAEA;AAEA;AAEA;AAEA;AAEA;AAEA;AAEA;AAEA","sourcesContent":["@import '../../../styles/customMediaQueries.css';\n\n.h1 {\n  composes: h1 from global;\n}\n\n.h2 {\n  composes: h2 from global;\n}\n\n.h3 {\n  composes: h3 from global;\n}\n\n.h4 {\n  composes: h4 from global;\n}\n\n.h5 {\n  composes: h5 from global;\n}\n\n.h6 {\n  composes: h6 from global;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"h1": `h1__uq7wp h1`,
	"h2": `h2__UkTyQ h2`,
	"h3": `h3__gNEMf h3`,
	"h4": `h4__qLv9n h4`,
	"h5": `h5___29pp h5`,
	"h6": `h6__ft0kw h6`
};
export default ___CSS_LOADER_EXPORT___;
